import React from 'react';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { MobileStickyBar } from '../components/layout/MobileStickyBar';
import { Footer } from '../components/layout/Footer';
import { Hero } from '../components/home/Hero';
import { DecisionCards } from '../components/home/DecisionCards';
import { PopularPaths } from '../components/home/PopularPaths';
import { GuidedBuyer } from '../components/home/GuidedBuyer';
import { CommercialStrip } from '../components/home/CommercialStrip';
import { InstallationService } from '../components/home/InstallationService';
import { Checklist } from '../components/home/Checklist';
import { ReviewsTrust } from '../components/home/ReviewsTrust';
export function Home() {
  return <div className="min-h-screen flex flex-col" data-id="element-589">
      <TopBar data-id="element-590" />
      <Header data-id="element-591" />
      <Navigation data-id="element-592" />

      <main className="flex-grow" data-id="element-593">
        <Hero data-id="element-594" />
        <DecisionCards data-id="element-595" />
        <PopularPaths data-id="element-596" />
        <GuidedBuyer data-id="element-597" />
        <CommercialStrip data-id="element-598" />
        <InstallationService data-id="element-599" />
        <Checklist data-id="element-600" />
        <ReviewsTrust data-id="element-601" />
      </main>

      <Footer data-id="element-602" />
      <MobileStickyBar data-id="element-603" />
    </div>;
}